import React from "react";
import { useTranslation } from "react-i18next";

function DateConverter(props) {
  const { t } = useTranslation();
  const { dateValue } = props; // Get the date value from props

  if (dateValue == null) return;

  // Convert the date value to a Date object
  const dateObject = new Date(dateValue.split("/").reverse().join("/"));

  // Get the current date
  const currentDate = new Date();

  // Age of posting (Days)
  var msDiff = currentDate.getTime() - dateObject.getTime();
  var daysDiff = Math.floor(msDiff / (1000 * 60 * 60 * 24));

  // Check if the date value is today's date
  if (
    dateObject.getDate() === currentDate.getDate() &&
    dateObject.getMonth() === currentDate.getMonth() &&
    dateObject.getFullYear() === currentDate.getFullYear()
  ) {
    return <div>{t("today")}</div>;
  } else if (daysDiff === 1) {
    return <div>{t("yesterday")}</div>;
  } else if (daysDiff >= 2 && daysDiff <= 4) {
    return <div>{t("few_days_ago")}</div>;
  }

  // Get the month as a string with the first three letters
  const month = dateObject.toLocaleString("default", { month: "short" });

  // Get the day and year
  const day = dateObject.getDate();
  const year = dateObject.getFullYear();

  // Format the date with the first three letters of the month in "dd-MMM-yyyy" format
  const formattedDate = `${day} ${t(month.toLocaleLowerCase())} ${year}`;

  return <>{formattedDate}</>;
}

export default DateConverter;
